import { queryStudentPapernew } from '@/api'
export default {
  name: 'projectDetails-page',
  data () {
    return {
      rou: 0,
      queryData: null,
      courseInfo: null, // 课程信息
      summary: null, // 出勤概况
      classDetail: null, // 课程内容
      gradientColor: {
        '0%': '#7CBEFB',
        '100%': '#4982FF'
      },
      currentRate: 0,
      value: 3,
      progress: null,
      participation: null,
      homework: null,
      homeworkDegree: null
    }
  },
  created () {
    this.getStudentEvaluationNote()
  },
  destroyed () { },
  methods: {
    Leavingmessage () {
      this.$router.push({ path: '/leavingMessage' })
    },
    async getStudentEvaluationNote () {
      let sellOrderId = null
      let classId = null
      let weekStr = null
      sellOrderId = this.getQueryString('sellOrderId')
      classId = this.getQueryString('classId')
      weekStr = this.getQueryString('weekStr')
      const { data } = await queryStudentPapernew({ sellOrderId: sellOrderId, classId: classId, weekStr: weekStr })
      this.queryData = data
      this.courseInfo = data.courseInfo
      this.summary = data.summary
      this.progress = data.progress
      this.participation = data.participation
      this.homework = data.homework
      this.homeworkDegree = data.homeworkDegree
      this.classDetail = data.classDetail ? data.classDetail : []
      this.rou = this.summary ? 180 * data.summary.up.scale - 180 : 0
    },
    getQueryString (name) {
      const url1 = window.location.search
      const url = decodeURI(url1)
      const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      const r = url.substr(1).match(reg)
      if (r != null) {
        return unescape(r[2])
      };
      return null
    }
  }
}
